// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"useModalDialog-module__wrapper___MN0hs"};